import _ from 'lodash';
import { logErrorToConsole, TravelTypes } from '../../constants';
import arePassengerCountsEqual from '../checkArePassengerCountsEqual';
import isOutboundFlightLegExistsInBrochure from '../checkIfFlightItineraryExistsInBrochure';

const checkDoTripExistInBrochure = (travelOption, staterooms) => (state) => {
  try {
    if (!state?.brochure?.brochure?.trips) return false;
    // if (state?.brochure?.brochure?.trips?.[travelOption.key]) return true;

    const keyCheckers = {
      [TravelTypes.flight]: (itinerary) => itinerary.flightKey === travelOption.key,
      [TravelTypes.hotel]: (itinerary) => itinerary.hotelKey === travelOption.key,
      [TravelTypes.carrental]: (itinerary) => itinerary.uniqueKey === travelOption.key,
      [TravelTypes.cruise]: (itinerary) => travelOption.key && _.includes(travelOption.key.split(':'), itinerary.itineraryDetail?.itineraryId),
    };

    const isMatchingSegment = (segment, trip) => {
      const { itinerary } = segment;
      if (!itinerary || itinerary.mode !== travelOption?.mode) return false;
      const doMatchesKey = keyCheckers[itinerary.mode]?.(itinerary) || false;
      const isStateroomsMatched = arePassengerCountsEqual(trip?.staterooms
        ?? trip?.roomSearchInput, staterooms);

      if (itinerary.mode === TravelTypes.cruise) {
        const { itineraryDetail } = itinerary;
        const itineraryRow = _.find(travelOption.itineraryRows,
          (row) => row.itineraryId === itineraryDetail?.itineraryId);
        if (!itineraryRow) return false;
        return doMatchesKey && isStateroomsMatched
            && itineraryDetail?.itineraryDepartDate === itineraryRow?.itineraryDepartDate
            && itineraryDetail?.itineraryReturnDate === itineraryRow?.itineraryReturnDate;
      }
      return doMatchesKey
      && itinerary.startDateTime === travelOption?.startDateTime
      && itinerary.endDateTime === travelOption?.endDateTime
      && isStateroomsMatched;
    };

    const doTripExistInBrochure = Object.values(state?.brochure?.brochure?.trips || {})
      ?.some((trip) => trip?.tripSegments?.some((segment) => isMatchingSegment(segment, trip)));
    const isFlightLegInBrochure = travelOption.mode === TravelTypes.flight
                  && !!isOutboundFlightLegExistsInBrochure(
                    state?.brochure?.brochure,
                    travelOption.flightItinerary.flightKey,
                  );
    return doTripExistInBrochure || isFlightLegInBrochure;
  } catch (error) {
    logErrorToConsole('Error in checkDoTripExistInBrochure: ', error);
    return false;
  }
};

export default checkDoTripExistInBrochure;
